import { TextButton } from "@swiggy-private/dls-web-core/dist/components/TextButton";
import styled from "styled-components";

export const StyledTextButton = styled(TextButton)(({ theme }) => ({
    marginRight: theme.spacing.small,
    marginLeft: theme.spacing.xxSmall,
}));
